function toggleChatWindowViaCard() {
  const event = new CustomEvent('rcb-card-click');
  window.dispatchEvent(event);
}

window.toggleChatWindowViaCard = toggleChatWindowViaCard;
